// ===================================
// VUE COMPONENT REGISTRATION
// ===================================
// Diese Datei MUSS vor vue-components.js geladen werden!

(function() {
	'use strict'
	
	if (typeof Vue === 'undefined') {
		console.error('❌ Vue.js nicht verfügbar für Component Registration')
		return
	}
	
	console.log('🔧 Registriere Vue Components...')
	
	// ===================================
	// MENU TREE PANEL COMPONENT (Dependency)
	// ===================================
	
	Vue.component('menu-tree-panel', {
		props: ['tree', 'rootPath', 'basePath', 'id'],
		template: `
			<div class="menu-tree-panel">
				<div v-if="tree && tree.length" class="tree-content">
					<ul class="menu-tree">
						<li v-for="(item, index) in tree" :key="item.id || index">
							<a v-if="item.url" :href="item.url" class="tree-link">
								{{ item.title || item.content }}
							</a>
							<span v-else class="tree-text">
								{{ item.title || item.content }}
							</span>
						</li>
					</ul>
				</div>
				<div v-else class="tree-empty">
					Keine Inhalte verfügbar
				</div>
			</div>
		`,
		mounted() {
			this.$emit('update:height', [200]) // Dummy height
		}
	})
	
	// =====================================================
	// DESKTOP MENU COMPONENT - KORRIGIERTE IMPLEMENTIERUNG
	// =====================================================
	// Diese Implementierung folgt dem Original Template-Pattern
	
	Vue.component('menu-desktop', {
		data() {
			return {
				path: '',
				location: window.location || {},
				miniLogo: window.miniLogo || {
					width: 77,
					height: 60,
					src: '/Images/Logos/logo-small@1x.png',
					src2: '/Images/Logos/logo-small@2x.png',
					srcSet: '/Images/Logos/logo-small@1x.png 77w, /Images/Logos/logo-small@2x.png 154w'
				},
				siteTree: window.siteTree || [
					{ id: 'about', content: 'ÜBER UNS', children: [] },
					{ id: 'institutes', content: 'INSTITUTE & MUSEEN', children: [] },
					{ id: 'research', content: 'FORSCHUNG', children: [] },
					{ id: 'career', content: 'KARRIERE', children: [] },
					{ id: 'media', content: 'MEDIEN', children: [] },
					{ id: 'events', content: 'VERANSTALTUNGEN', children: [] }
				],
				strings: {
					en: { BACK: 'Back', CLOSE: 'Close' },
					de: { BACK: 'Zurück', CLOSE: 'Schließen' }
				},
				locale: 'de',
				iconsSvg: window.iconsSvg || '/Images/icons.svg',
				
				// STICKY HEADER PROPERTIES
				tabsStuck: false,
				lastScrollPosn: 0,
				layerOuter: null,
				layerInner: null,
				layerUpper: null
			}
		},
		
		computed: {
			homeLink() {
				return this.locale == 'en' ? '/en/' : '/'
			},
			pathArr() {
				return this.path.length ? this.path.split('-') : []
			},
			isOpen() {
				return this.pathArr.length > 0
			},
			columns() {
				return window.innerWidth >= 1664 ? 3 : 2 // xl breakpoint
			},
			columnOffset() {
				return Math.max(0, this.pathArr.length - this.columns)
			},
			pushStyle() {
				return {
					transform: `translateX(${(this.columnOffset * -100) / this.columns}%)`
				}
			}
		},
		
		template: `
			<div class="layer-lower d-none d-block__l " 
				id="menu-desktop"
				role="navigation"
				aria-label="Hauptmenü"
				tabindex="-1">
				
				<div class="tabs-outer rel" ref="tabs-outer">
					<div class="tabs-inner w-100" ref="tabs-inner">
						<div class="wrap-last clip pb-s">
							<!--<div class="tabs-frame frame bg-lite">-->
							<div class="tabs-frame  bg-lite">
								
								<div class="tabs-list chain-s ai-center jc-center rel">
									<a class="home-link abs d-flex ai-center"
										:href="homeLink"
										:style="'width: ' + miniLogo.width + 'px'">
										<img :style="'height: ' + miniLogo.height + 'px; width: ' + miniLogo.width + 'px'"
											:sizes="miniLogo.width + 'px'"
											:srcset="miniLogo.srcSet"
											:src="miniLogo.src2"
											alt="Leibniz Gemeinschaft, Logo">
									</a>
									
									<button v-for="(branch, i) in siteTree"
											:key="branch.id"
											class="menu-toggle sans-m1"
											type="button"
											role="tab"
											@click="setPath(i)"
											@keydown="handleTabKeydown($event, i)"
											:class="{ 'inpath': inPath(i) }"
											:id="'desktop-menu-tab-' + branch.id"
											:aria-controls="'desktop-menu-panel-' + branch.id"
											:aria-selected="String(inPath(i))"
											:aria-expanded="String(inPath(i))"
											v-html="branch.content">
									</button>
									
									<div class="tabs-actions abs chain-s ai-center">
										<a href="/en/" class="lang-toggle sans-m2 strong">EN</a>
										<button class="search-toggle"
												type="button"
												aria-label="Suche öffnen"
												aria-controls="search-layer"
												aria-expanded="false">
											<span class="icon icon-s">
												<svg aria-hidden="true">
													<use :xlink:href="iconsSvg + '#icon-search-s'"></use>
												</svg>
											</span>
										</button>
									</div>
									
								</div>
								
							</div>
						</div>
					</div>
				</div>
				
				<transition name="fade">
					<div v-show="isOpen"
						class="panels-outer rel wrap-last find-button"
						ref="panels-outer"
						id="desktop-menu-panels"
						role="region"
						:aria-hidden="String(!isOpen)">
						
						<div class="panels-inner frame stack-m py-m fg-lite">
							
							<!--
							<div class="hold d-flex">
								
								<div class="menu-back" :class="{ active: columnOffset > 0 }">
									<button class="link-outer d-flex ai-center"
											ref="back"
											:tabindex="isOpen && columnOffset > 0 ? 0 : -1"
											type="button"
											@click="reducePath">
										<span class="d-block icon icon-s">
											<svg aria-hidden="true">
												<use :xlink:href="iconsSvg + '#icon-chevron-left-s'"></use>
											</svg>
										</span>
										<span class="d-block link-inner ml-xxs">{{ strings[locale].BACK }}</span>
									</button>
								</div>
								
								
								<button class="ml-auto fx-0-0"
										type="button"
										aria-controls="desktop-menu-panels"
										:aria-label="strings[locale].CLOSE"
										:aria-expanded="String(isOpen)"
										@click="path = ''">
									<span class="d-block icon icon-s">
										<svg aria-hidden="true">
											<use :xlink:href="iconsSvg + '#icon-close-m'"></use>
										</svg>
									</span>
								</button>
							</div>
							-->
							<button class="ml-auto fx-0-0"
									type="button"
									aria-controls="desktop-menu-panels"
									:aria-label="strings[locale].CLOSE"
									:aria-expanded="String(isOpen)"
									@click="path = ''">
								<span class="d-block icon icon-s">
									<svg aria-hidden="true">
										<use :xlink:href="iconsSvg + '#icon-close-m'"></use>
									</svg>
								</span>
							</button>
							
							<div class="menu-clip clip" ref="clip">
								<div class="menu-push flow-s" ref="push" :style="pushStyle">
									<transition name="cross-fade" mode="out-in">
										
										<!--
										<menu-tree-panel v-for="(branch, i) in siteTree"
														v-if="inPath(i)"
														:key="branch.id"
														:id="'desktop-menu-panel-' + branch.id"
														:aria-labelledby="'desktop-menu-tab-' + branch.id"
														:aria-hidden="String(!inPath(i))"
														:tree="branch.children"
														:rootPath="path"
														:basePath="[i]"
														role="tabpanel"
														@update:path="updatePath"
														@update:height="updateHeight">
										</menu-tree-panel>
										-->
										<menu-mega-panel v-for="(branch, i) in siteTree"
														 v-if="inPath(i)"
														 :key="branch.id"
														 :id="'desktop-menu-panel-' + branch.id"
														 :tree="branch.children"
														 @update:height="updateHeight">
										</menu-mega-panel>
										
									</transition>
								</div>
							</div>
							
						</div>
					</div>
				</transition>
				
			</div>
		`,
		
		methods: {
			pathStr(...n) {
				return n.join('-')
			},
			
			inPath(...n) {
				const pathToCheck = this.pathStr(...n)
				return new RegExp(`^${pathToCheck}`).test(this.path)
			},
			
			// KORRIGIERT: setPath verwendet '-' als Separator (wie im Original)
			setPath(...nums) {
				this.path = nums.join('-') // KORRIGIERT: war vorher join('')
				console.log('🎯 Desktop Menu: setPath to', this.path)
			},
			
			reducePath() {
				this.path = this.pathArr.slice(0, this.pathArr.length - 1).join('-')
			},
			
			updatePath(pathArr) {
				this.path = pathArr.join('-')
			},
			
			updateHeight(heightsArr) {
				const height = Math.max(...heightsArr.slice(0, this.columns))
				if (this.$refs.clip) {
					this.$refs.clip.style.transition = 'height 0.2s ease'
					this.$refs.clip.style.height = height + 'px'
				}
			},
			
			handleTabKeydown(event, index) {
				if (event.key === 'ArrowRight') {
					const next = (index + 1) % this.siteTree.length
					this.setPath(next)
				}
				if (event.key === 'ArrowLeft') {
					const prev = (index - 1 + this.siteTree.length) % this.siteTree.length
					this.setPath(prev)
				}
			},
			
			// KORRIGIERTE PANEL MANAGEMENT FUNCTIONS
			openPanel() {
				console.log('📖 Panel opening - setting up sticky behavior')
				this.lastScrollPosn = window.pageYOffset
				const headerScroll = Math.min(this.lastScrollPosn, this.layerUpper.getBoundingClientRect().height)
				
				// Body Modal state
				document.body.classList.add('has-modal')
				this.layerInner.classList.add('fix')
				
				this.updateLayerHeight()
				
				this.$nextTick(() => {
					console.log('📖 Setting initial scroll position:', headerScroll)
					this.layerInner.scrollTop = headerScroll
					
					// Switch from window scroll to layer scroll
					window.removeEventListener('scroll', this.updateTabSticking)
					this.layerInner.addEventListener('scroll', this.updateTabSticking, { passive: true })
				})
				
				this.$nextTick(() => {
					this.focusFirstPanelItem()
				})
			},
	
			closePanel() {
				console.log('📖 Panel closing - restoring normal scroll')
				const headerScroll = this.layerInner.scrollTop
				
				// Remove Modal state
				this.layerInner.classList.remove('fix')
				document.body.classList.remove('has-modal')
				
				this.updateLayerHeight()
				
				this.$nextTick(() => {
					// Restore window scroll position
					window.scroll(0, Math.max(headerScroll, this.lastScrollPosn))
					this.layerInner.scrollTop = 0
					
					// Switch back to window scroll
					this.layerInner.removeEventListener('scroll', this.updateTabSticking)
					window.addEventListener('scroll', this.updateTabSticking, { passive: true })
				})
			},
	
			updateLayerHeight() {
				console.log('📏 Updating layer height, isOpen:', this.isOpen)
				if (!this.isOpen) {
					this.layerOuter.style.height = 'auto'
				} else {
					const { height } = this.layerInner.getBoundingClientRect()
					this.layerOuter.style.height = `${height}px`
				}
				this.updateTabSticking()
			},
	
			// KORRIGIERT: Tippfehler "udpateTabSticking" → "updateTabSticking"
			updateTabSticking() {
				// Check if tabs should stick to top
				const shouldStick = Math.floor(this.$refs['tabs-outer'].getBoundingClientRect().top) <= 0
				
				if (shouldStick !== this.tabsStuck) {
					console.log('📌 Tab sticking state changed:', shouldStick)
					
					const tabsInner = this.$refs['tabs-inner']
					if (shouldStick) {
						tabsInner.classList.add('fix', 'frozen-width', 'frozen-right')
					} else {
						tabsInner.classList.remove('fix', 'frozen-width', 'frozen-right')
					}
					
					this.tabsStuck = shouldStick
				}
			},
			
			focusFirstPanelItem() {
				// Dummy implementation - würde im Original auf erstes focusable Element fokussieren
				console.log('🔍 Focus first panel item')
			}
		},
		
		created() {
			// Get locale from document lang
			this.locale = document.documentElement.getAttribute('lang') || 'de'
		},
		
		mounted() {
			console.log('🖥️ Desktop Menu Component mounted - KORRIGIERTE VERSION')
			
			// ==========================================
			// STICKY HEADER SETUP (FEHLTE VORHER!)
			// ==========================================
			
			// Get required DOM elements for sticky behavior
			const pageHeader = document.querySelector('#page-header')
			if (pageHeader) {
				this.layerOuter = pageHeader.querySelector('.desktop-layer-outer')
				this.layerInner = pageHeader.querySelector('.desktop-layer-inner')
				this.layerUpper = pageHeader.querySelector('.layer-upper')
				
				if (this.layerOuter && this.layerInner && this.layerUpper) {
					// Setup scroll listeners for sticky behavior
					window.addEventListener('scroll', this.updateTabSticking, { passive: true })
					window.addEventListener('resize', this.updateLayerHeight, { passive: true })
					
					// Initial setup
					this.updateLayerHeight()
					
					console.log('✅ Sticky header system initialized')
				} else {
					console.warn('⚠️ Could not find required DOM elements for sticky header')
				}
			}
			
			// Reset path when clicking away from open panel
			document.addEventListener('click', event => {
				if (
					this.path.length &&
					event.target.closest('.menu-toggle') == null &&
					event.target.closest('.panels-inner') == null
				) {
					this.path = ''
				}
			})
			
			// Dev: if path is already set, open the panel
			if (this.path.length) {
				this.openPanel()
			}
		},
		
		watch: {
			pathArr(newVal, oldVal) {
				// Handle panel state changes (opening/closing)
				const newLength = newVal.length
				const oldLength = oldVal.length
				
				// Panel state changed from closed to open OR open to closed
				if (~[newLength, oldLength].indexOf(0)) {
					if (this.isOpen) {
						this.openPanel()
					} else {
						this.closePanel()
					}
				}
				
				// Handle tab switching (when both old and new are length 1)
				if (~[newLength, oldLength].indexOf(1)) {
					// Reset clip height for smooth transition
					if (this.$refs.clip) {
						this.$refs.clip.style.height = 'auto'
					}
				}
				
				console.log('📄 Path changed from', oldVal, 'to', newVal, '- Panel state:', this.isOpen ? 'OPEN' : 'CLOSED')
			}
		}
	})
	
	// ===================
	// MENU SIDEBAR COMPONENT (Vue 2 FIXED)
	// ===================
	Vue.component('menu-sidebar', {
		data() {
			return {
				isOpen: false,
				pages: [],
				basePath: [],
				location: window.location || {}
			}
		},
		
		template: `
			<div id="menu-desktop-side" class="d-none d-block__l">
				
				<!-- Toggle Button -->
				<button class="menu-toggle d-block"
						ref="toggle"
						type="button"
						id="menu-desktop-side-toggle"
						:aria-expanded="String(isOpen)"
						@click="toggle">
					
					<!-- SVG Icon -->
					<div class="hold-svg">
						<svg viewBox="0 0 76 65" xmlns="http://www.w3.org/2000/svg" class="fg-scirocco">
							<path d="M41.73 1.1C64.35-1.69 79.297 11.198 75.116 29.89c-4.18 18.69-17.154 37.27-35.572 34.592C21.127 61.804.833 43.32.81 30.097.789 16.874 19.109 3.892 41.729 1.1z" 
								fill="currentColor"/>
						</svg>
					</div>
					
					<!-- Decorative Elements -->
					<div class="dots fg-lite"></div>
					<div class="bars fg-lite"></div>
				</button>
				
				<!-- Menu Content -->
				<transition :css="false"
							@enter="enterTrans"
							@leave="leaveTrans">
					<div v-show="isOpen"
						class="menu-content py-s px-s bg-scirocco fg-lite"
						role="region"
						:aria-hidden="String(!isOpen)">
						
						<nav class="sans-m2 strong stack-s" 
							role="navigation" 
							aria-label="Unterseiten Menü">
							
							<!-- Breadcrumbs - VUE 2 FIXED -->
							<div class="crumbs" v-if="basePath.length">
								<template v-for="(crumb, i) in basePath">
									<a v-if="crumb.url && location.pathname !== crumb.url"
										:key="'link-' + i"
										class="link"
										:href="crumb.url">
										{{ crumb.content }}
									</a>
									<span v-else :key="'span-' + i">{{ crumb.content }}</span>
									<span v-if="i < (basePath.length - 1)" :key="'spacer-' + i" class="spacer"> &gt; </span>
								</template>
							</div>
							
							<!-- Page Links -->
							<div class="stack-xs">
								<p v-for="page in pages" :key="page.id || page.url" class="menu-link">
									<a class="link" 
										:href="location.pathname === page.url ? '#menu-desktop-side' : page.url">
										{{ page.content }}
									</a>
								</p>
							</div>
							
							<!-- Fallback wenn keine Pages -->
							<div v-if="!pages.length" class="stack-xs">
								<p class="menu-link">
									<span>Keine Unterseiten verfügbar</span>
								</p>
							</div>
							
						</nav>
					</div>
				</transition>
				
			</div>
		`,
		
		methods: {
			toggle() {
				this.isOpen = !this.isOpen
			},
			
			enterTrans(el, done) {
				// Simple enter animation
				el.style.opacity = '0'
				el.style.transform = 'translateY(-10px)'
				
				requestAnimationFrame(() => {
					el.style.transition = 'all 0.3s ease'
					el.style.opacity = '1'
					el.style.transform = 'translateY(0)'
					setTimeout(done, 300)
				})
			},
			
			leaveTrans(el, done) {
				// Simple leave animation
				el.style.transition = 'all 0.2s ease'
				el.style.opacity = '0'
				el.style.transform = 'translateY(-10px)'
				setTimeout(done, 200)
			}
		},
		
		mounted() {
			console.log('📋 Sidebar Menu Component mounted')
			console.log('Pages available:', this.pages.length)
			console.log('Base path:', this.basePath.length)
		}
	})
	
	// ===================================
	// SIDEBAR MENU COMPONENT - VUE 2 FIXED
	// ===================================
	
	Vue.component('menu-sidebar', {
		data() {
			return {
				location: window.location || {},
				isOpen: false,
				toggledViewTop: 0,
				basePath: (window.subPages && window.subPages.path) || [],
				pages: (window.subPages && window.subPages.pages) || [],
				tracky: null
			}
		},
		
		template: `
			<div id="menu-desktop-side" class="d-none d-block__l ">
				
				<!-- Toggle Button -->
				<button class="menu-toggle d-block "
						ref="toggle"
						type="button"
						id="menu-desktop-side-toggle"
						:aria-expanded="String(isOpen)"
						@click="toggle">
					
					<!-- SVG Icon -->
					<div class="hold-svg">
						<svg viewBox="0 0 76 65" xmlns="http://www.w3.org/2000/svg" class="fg-scirocco">
							<path d="M41.73 1.1C64.35-1.69 79.297 11.198 75.116 29.89c-4.18 18.69-17.154 37.27-35.572 34.592C21.127 61.804.833 43.32.81 30.097.789 16.874 19.109 3.892 41.729 1.1z" 
								fill="currentColor"/>
						</svg>
					</div>
					
					<!-- Decorative Elements -->
					<div class="dots fg-lite"></div>
					<div class="bars fg-lite"></div>
				</button>
				
				<!-- Menu Content -->
				<transition :css="false"
							@enter="enterTrans"
							@leave="leaveTrans">
					<div v-show="isOpen"
						class="menu-content py-s px-s bg-scirocco fg-lite"
						role="region"
						:aria-hidden="String(!isOpen)">
						
						<nav class="sans-m2 strong stack-s" 
							role="navigation" 
							aria-label="Unterseiten Menü">
							
							<!-- Breadcrumbs - VUE 2 FIXED -->
							<div class="crumbs" v-if="basePath.length">
								<template v-for="(crumb, i) in basePath">
									<a v-if="crumb.url && location.pathname !== crumb.url"
										:key="'link-' + i"
										class="link"
										:href="crumb.url">
										{{ crumb.content }}
									</a>
									<span v-else :key="'span-' + i">{{ crumb.content }}</span>
									<span v-if="i < (basePath.length - 1)" :key="'spacer-' + i" class="spacer"> &gt; </span>
								</template>
							</div>
							
							<!-- Page Links -->
							<div class="stack-xs">
								<p v-for="page in pages" :key="page.id || page.url" class="menu-link">
									<a class="link" 
										:href="location.pathname === page.url ? '#menu-desktop-side' : page.url">
										{{ page.content }}
									</a>
								</p>
							</div>
							
							<!-- Fallback wenn keine Pages -->
							<div v-if="!pages.length" class="stack-xs">
								<p class="menu-link">
									<span>Keine Unterseiten verfügbar</span>
								</p>
							</div>
							
						</nav>
					</div>
				</transition>
				
			</div>
		`,
		
		methods: {
			enterTrans(el, done) {
				// Simplified enter animation without GSAP
				el.style.height = 'auto'
				const height = el.getBoundingClientRect().height
				el.style.height = '0px'
				el.style.transition = 'height 0.2s ease'
				
				requestAnimationFrame(() => {
					el.style.height = height + 'px'
					setTimeout(done, 200)
				})
			},
			
			leaveTrans(el, done) {
				// Simplified leave animation without GSAP
				el.style.transition = 'height 0.2s ease'
				el.style.height = '0px'
				setTimeout(() => {
					el.style.height = 'auto'
					done()
				}, 200)
			},
			
			toggle() {
				this.isOpen = !this.isOpen
				this.toggledViewTop = window.pageYOffset || 0
				
				// Simplified scroll compensation without GSAP
				if (!this.isOpen) {
					this.$el.style.transform = 'translateY(0)'
				}
				
				console.log('📋 Sidebar menu:', this.isOpen ? 'opened' : 'closed')
			},
			
			setupScrollTracking() {
				// Simplified scroll tracking without Tracky
				let ticking = false
				
				const handleScroll = () => {
					if (!ticking && this.isOpen) {
						requestAnimationFrame(() => {
							const currentViewTop = window.pageYOffset || 0
							const offset = this.toggledViewTop - currentViewTop
							this.$el.style.transform = `translateY(${offset}px)`
							ticking = false
						})
						ticking = true
					}
				}
				
				window.addEventListener('scroll', handleScroll, { passive: true })
			},
			
			isInTree(child, parent = document) {
				let node = child.parentNode
				while (node != null) {
					if (node === parent) {
						return true
					}
					node = node.parentNode
				}
				return false
			}
		},
		
		mounted() {
			console.log('📋 Sidebar Menu Component mounted')
			console.log('Pages available:', this.pages.length)
			console.log('Base path:', this.basePath.length)
			
			// Setup scroll tracking
			this.setupScrollTracking()
			
			// Focus management (simplified)
			document.addEventListener('click', (e) => {
				if (this.isOpen && !this.isInTree(e.target, this.$el)) {
					this.isOpen = false
				}
			})
		}
	})
	
	// ===================================
	// PHABLET MENU COMPONENT (Mobile Navigation)
	// ===================================
	
	Vue.component('menu-phablet', {
		data() {
			return {
				path: '',
				location: window.location || {},
				siteTree: window.siteTree || [
					{ id: 'about', content: 'ÜBER UNS', children: [] },
					{ id: 'institutes', content: 'INSTITUTE & MUSEEN', children: [] },
					{ id: 'research', content: 'FORSCHUNG', children: [] },
					{ id: 'career', content: 'KARRIERE', children: [] },
					{ id: 'media', content: 'MEDIEN', children: [] },
					{ id: 'events', content: 'VERANSTALTUNGEN', children: [] }
				],
				strings: {
					en: { BACK: 'Back' },
					de: { BACK: 'Zurück' }
				},
				locale: 'de',
				iconsSvg: window.iconsSvg || '/Images/icons.svg',
				isOpen: false
			}
		},
		
		computed: {
			pathArr() {
				return this.path.length ? this.path.split('-') : []
			},
			columns() {
				return window.innerWidth >= 832 ? 2 : 1 // m breakpoint
			},
			columnOffset() {
				return Math.max(0, this.pathArr.length - this.columns + 1)
			},
			pushStyle() {
				return {
					transform: `translateX(${(this.columnOffset * -100) / this.columns}%)`
				}
			}
		},
		
		template: `
			<div class="menu-main frame stack-m fg-lite" id="menu-phablet">
				
				<!-- Back Button -->
				<div class="hold menu-back" :class="{ active: columnOffset > 0 }">
					<button class="link-outer d-flex ai-center"
							ref="back"
							:tabindex="columnOffset > 0 ? 0 : -1"
							type="button"
							@click="reducePath">
						<span class="d-block icon icon-s">
							<svg>
								<use :xlink:href="iconsSvg + '#icon-chevron-left-s'"></use>
							</svg>
						</span>
						<span class="d-block link-inner ml-xxs">{{ strings[locale].BACK }}</span>
					</button>
				</div>
				
				<!-- Menu Content -->
				<div class="menu-clip clip" ref="clip">
					<div class="menu-push flow-s" ref="push" :style="pushStyle">
						
						<!-- Root Menu Tree -->
						<menu-tree-panel class="menu-tree-root"
										:tree="siteTree"
										:rootPath="path"
										:basePath="[]"
										@update:path="updatePath"
										@update:height="updateHeight">
						</menu-tree-panel>
						
					</div>
				</div>
				
			</div>
		`,
		
		methods: {
			updatePath(pathArr) {
				this.path = pathArr.join('-')
			},
			
			reducePath() {
				this.path = this.pathArr.slice(0, this.pathArr.length - 1).join('-')
			},
			
			updateHeight(heightsArr) {
				const height = Math.max(...heightsArr.slice(0, this.columns))
				console.log('Phablet menu height:', height)
				
				// Simplified height animation without GSAP
				if (this.$refs.clip) {
					this.$refs.clip.style.transition = 'height 0.2s ease'
					this.$refs.clip.style.height = height + 'px'
				}
			},
			
			setupExternalToggles() {
				// Setup mobile menu toggles
				const pageHeader = document.querySelector('#page-header')
				const phabletOuter = document.querySelector('#menu-phablet-outer')
				const phabletHeader = document.querySelector('.phablet-meta')
				const phabletToggles = document.querySelectorAll('.phablet-toggle')
				
				if (!pageHeader || !phabletOuter || !phabletToggles.length) {
					console.warn('⚠️ Phablet menu elements nicht gefunden')
					return
				}
				
				// Toggle functionality
				phabletToggles.forEach(toggle => {
					toggle.addEventListener('click', event => {
						this.isOpen = !this.isOpen
						phabletOuter.classList.toggle('active', this.isOpen)
						document.body.classList.toggle('has-modal', this.isOpen)
						
						phabletToggles.forEach(btn => {
							btn.setAttribute('aria-expanded', String(this.isOpen))
						})
						
						if (!this.isOpen) {
							if (this.$refs.clip) {
								this.$refs.clip.style.height = 'auto'
							}
							this.path = ''
						}
						
						console.log('📱 Phablet menu:', this.isOpen ? 'opened' : 'closed')
					})
				})
				
				// Header sticking behavior
				let isBelowPageHeader = false
				const updateHeaderPosition = () => {
					const isBelow = window.pageYOffset > pageHeader.getBoundingClientRect().height
					if (isBelow !== isBelowPageHeader && phabletHeader) {
						phabletHeader.classList.toggle('below', isBelow)
						isBelowPageHeader = isBelow
					}
				}
				
				window.addEventListener('scroll', updateHeaderPosition, { passive: true })
				window.addEventListener('resize', updateHeaderPosition, { passive: true })
				updateHeaderPosition()
			},
			
			setupMediaQueries() {
				// Close mobile menu when switching to desktop
				const checkDesktop = () => {
					if (window.innerWidth >= 1152) { // l breakpoint
						this.path = ''
						this.isOpen = false
						
						const phabletOuter = document.querySelector('#menu-phablet-outer')
						if (phabletOuter) {
							phabletOuter.classList.remove('active')
						}
						document.body.classList.remove('has-modal')
					}
				}
				
				window.addEventListener('resize', checkDesktop, { passive: true })
			}
		},
		
		created() {
			// Get locale from document
			this.locale = document.documentElement.getAttribute('lang') || 'de'
		},
		
		mounted() {
			console.log('📱 Phablet Menu Component mounted')
			
			// Setup external DOM interactions
			this.$nextTick(() => {
				this.setupExternalToggles()
				this.setupMediaQueries()
			})
		},
		
		watch: {
			pathArr(newVal, oldVal) {
				// Reset height when going back to root
				if (newVal.length === 0 && this.$refs.push) {
					const height = this.$refs.push.getBoundingClientRect().height
					this.updateHeight([height])
				}
			}
		}
	})
	
	// ===================================
	// FAKT TEASER COMPONENT
	// ===================================
	
	Vue.component('fakt-teaser', {
		props: {
			btnHtml: {
				type: String,
				default: 'Weiter'
			},
			btnLabel: {
				type: String,
				default: 'Nächster Fakt'
			}
		},
		
		data() {
			return {
				faktList: window.faktList || [
					{
						meta: 'Beispiel-Fakt',
						num: '42',
						text: 'Dies ist ein Beispiel-Fakt für die Darstellung.'
					},
					{
						meta: 'Wissenschaft',
						num: '73%',
						text: 'Ein weiterer interessanter Fakt zum Durchklicken.'
					},
					{
						meta: 'Forschung',
						num: '2024',
						text: 'Noch ein Fakt mit aktuellen Zahlen und Daten.'
					}
				],
				currIndex: 0
			}
		},
		
		computed: {
			fakt() {
				return this.faktList[this.currIndex] || this.faktList[0]
			}
		},
		
		template: `
			<li class="teaser-item teaser-item-fakt teaser-item-single" aria-live="polite">
				<div class="stack-xs">
					
					<!-- Meta & Number -->
					<div class="stack-xxs">
						<p class="mono-i1">{{ fakt.meta }}</p>
						<h4 class="sans-h1 strong">{{ fakt.num }}</h4>
					</div>
					
					<!-- Fact Text -->
					<div class="sans-t2 strong">{{ fakt.text }}</div>
					
					<!-- Next Button -->
					<div class="sans-m2 strong">
						<button class="btn-icon-left btn-s btn-link trim"
								:aria-label="btnLabel"
								v-html="btnHtml"
								@click="next">
						</button>
					</div>
					
				</div>
			</li>
		`,
		
		methods: {
			next() {
				// Cycle to next fact
				if (this.currIndex >= this.faktList.length - 1) {
					this.currIndex = 0
				} else {
					this.currIndex++
				}
				
				console.log(`📊 Fakt ${this.currIndex + 1}/${this.faktList.length}:`, this.fakt.text.substring(0, 30) + '...')
				
				// Emit event for tracking
				this.$emit('fact-changed', {
					index: this.currIndex,
					fact: this.fakt
				})
			}
		},
		
		mounted() {
			console.log('📊 Fakt Teaser Component mounted')
			console.log(`Facts available: ${this.faktList.length}`)
			
			if (!window.faktList) {
				console.warn('⚠️ window.faktList nicht gefunden - verwende Fallback-Daten')
			}
		}
	})
	
	console.log('✅ Vue Components registriert')
	
})()

// ===================================
// MENU TREE LEVEL COMPONENT
// ===================================

// ===================================
// MENU TREE LEVEL COMPONENT
// ===================================

Vue.component('menu-tree-level', {
	props: ['tree', 'rootPath', 'basePath', 'index'],
	
	data() {
		return {
			location: window.location || {},
			iconsSvg: window.iconsSvg || '/Images/Icons/icons.svg',
			buttonID: `menu-tree-level-button-${Math.random().toString(36).substr(2, 9)}`,
			submenuID: `menu-tree-level-content-${Math.random().toString(36).substr(2, 9)}`
		}
	},
	
	computed: {
		rootPathArr() {
			return this.rootPath && this.rootPath.length ? this.rootPath.split('-') : []
		},
		childPath() {
			return [...this.basePath, this.index]
		},
		childVisible() {
			const rootArr = this.rootPathArr
			const myDepth = this.basePath.length
			
			// KORRIGIERTE LOGIC:
			// Ein Child ist sichtbar wenn der rootPath mindestens so tief ist wie basePath + 1
			// UND der Index an meiner Position stimmt
			const isDeepEnough = rootArr.length > myDepth
			const isMyIndex = rootArr[myDepth] == this.index
			const result = isDeepEnough && isMyIndex
			
			return result
		},
		inPath() {
			// Ein Item ist "in path" wenn es Teil des aktuellen Pfads ist
			const rootArr = this.rootPathArr
			const myDepth = this.basePath.length
			
			// Prüfe ob mein Index an meiner Position im rootPath steht
			return rootArr.length > myDepth && rootArr[myDepth] == this.index
		},
		hasChildren() {
			return this.tree.children && this.tree.children.length > 0
		},
		isLeafWithUrl() {
			return this.tree.url && !this.hasChildren
		}
	},
	
	template: `
		<li class="menu-tree-level sans-m1">
			
			<!-- Link für Leaf-Items (haben URL aber keine Kinder) -->
			<a v-if="isLeafWithUrl"
				class="link-outer d-flex ai-center w-100"
				:href="location.pathname === tree.url ? '#menu-sidebar' : tree.url"
				:class="{ inpath: inPath }">
				<span>
					<span class="link-inner" v-html="tree.content"></span>
				</span>
				<span v-if="hasChildren" class="icon icon-s ml-auto">
					<svg aria-hidden="true">
						<use :xlink:href="iconsSvg + '#icon-chevron-right-s'"></use>
					</svg>
				</span>
			</a>
			
			<!-- Button für Parent-Items (haben Kinder) -->
			<button v-else
					class="link-outer d-flex ai-center w-100"
					ref="btn"
					type="button"
					:id="buttonID"
					:aria-expanded="String(childVisible)"
					:class="{ inpath: inPath }"
					@click="navigateToLevel">
				<span>
					<span class="link-inner" v-html="tree.content"></span>
				</span>
				<span v-if="hasChildren" class="icon icon-s ml-auto">
					<svg aria-hidden="true">
						<use :xlink:href="iconsSvg + '#icon-chevron-right-s'"></use>
					</svg>
				</span>
			</button>
			
			<!-- Sub-Menu für Items mit Kindern -->
			<template v-if="hasChildren">
				<transition name="fade" appear>
					<div v-show="childVisible"
						class="menu-tree-child stack-s"
						role="region"
						ref="child"
						:id="submenuID"
						:aria-hidden="String(!childVisible)">
						
						<!-- Link zum Parent Item falls es eine URL hat -->
						<a v-if="tree.url"
							class="link-outer"
							ref="link"
							:href="location.pathname === tree.url ? '#menu-sidebar' : tree.url">
							<span>
								<span class="link-inner" v-html="capitalize(tree.content)"></span>
							</span>
						</a>
						
						<!-- Liste der Child Items -->
						<ul class="stack-xs">
							<menu-tree-level v-for="(branch, j) in tree.children"
											:key="branch.id || j"
											:tree="branch"
											:index="j"
											:basePath="childPath"
											:rootPath="rootPath"
											@update:path="updatePath"
											@update:height="updateHeight">
							</menu-tree-level>
						</ul>
						
					</div>
				</transition>
			</template>
			
		</li>
	`,
	
	methods: {
		navigateToLevel() {
			// ERWEITERTE DEBUG-INFO
			console.log('🔄 Navigation DEBUG:', {
				item: this.tree.content,
				myBasePath: this.basePath,
				myIndex: this.index,
				currentRootPath: this.rootPath,
				currentRootPathArr: this.rootPathArr,
				targetPath: this.basePath.concat([this.index])
			})
		
			const targetPath = this.basePath.concat([this.index])
			this.updatePath(targetPath)
		},
		
		capitalize(value) {  // ← Das fehlte!
			return value ? value.toString().toUpperCase() : ''
		},
		
		updatePath(pathArr) {
			this.$emit('update:path', pathArr)
		},
		
		updateHeight(heightsArr) {
			this.$emit('update:height', heightsArr)
		},
		
		// Helper function to get parent VMs (ersetzt $parents)
		getParents() {
			const parents = []
			let vm = this.$parent
			while (vm) {
				parents.push(vm)
				vm = vm.$parent
			}
			return parents
		}
	},
	
	watch: {
		rootPath(rootPath) {
			if (
				(this.childVisible && this.childPath.join('-') === rootPath) ||
				(this.childVisible && this.basePath.join('-') === rootPath)
			) {
				this.$nextTick(() => {
					// Sammle alle child Refs von diesem und Parent Components
					const allVMs = [this, ...this.getParents()]
					const childEls = allVMs
						.map(vm => vm.$refs.child)
						.filter(el => el)
					
					if (childEls.length > 0) {
						const heightsArr = childEls
							.map(el => el.getBoundingClientRect().height)
							.filter(height => height > 0)
						
						if (heightsArr.length > 0) {
							this.$emit('update:height', heightsArr)
						}
					}
				})
			}
		}
	},
	
	mounted() {
		// console.log('🌳 MenuTreeLevel mounted:', this.tree.content)
	}
})

// ===================================
// MENU TREE PANEL COMPONENT  
// ===================================

Vue.component('menu-tree-panel', {
	props: ['tree', 'rootPath', 'basePath'],
	
	template: `
		<ul class="menu-tree-panel stack-xs"
			ref="child"
			role="region">
			
			<menu-tree-level v-for="(branch, i) in tree"
							:key="branch.id || i"
							:tree="branch"
							:index="i"
							:rootPath="rootPath"
							:basePath="basePath"
							@update:path="updatePath"
							@update:height="updateHeight">
			</menu-tree-level>
			
		</ul>
	`,
	
	methods: {
		updatePath(pathArr) {
			this.$emit('update:path', pathArr)
		},
		
		updateHeight(heightsArr) {
			this.$emit('update:height', heightsArr)
		}
	},
	
	mounted() {
		console.log('🌲 MenuTreePanel mounted with', this.tree ? this.tree.length : 0, 'top-level items')
	}
})


// ===================================
// MENU MEGA PANEL COMPONENT (DESKTOP ONLY)
// ===================================

Vue.component('menu-mega-panel', {
	props: ['tree', 'rootPath', 'basePath'],
	
	template: `
		<div class="menu-mega-panel">
			<div v-if="tree && tree.length" class="mega-grid">
				
				<!-- Ebene 2: Spalten -->
				<div class="mega-column" 
					 v-for="(level2, colIndex) in tree" 
					 :key="level2.id || colIndex">
					
					<!-- Spaltenüberschrift -->
					<div class="mega-column-header">
						<a v-if="level2.url" :href="level2.url" class="link-outer">
							<span><span class="link-inner">{{ level2.content }}</span></span>
						</a>
						<span v-else class="column-title">{{ level2.content }}</span>
					</div>
					
					<!-- Ebene 3: Gruppen -->
					<ul v-if="level2.children && level2.children.length" class="mega-groups stack-s">
						<li class="mega-group stack-xxs" 
							v-for="(level3, groupIndex) in level2.children" 
							:key="level3.id || groupIndex">
							
							<!-- Gruppenüberschrift -->
							<a v-if="level3.url" :href="level3.url" class="group-title link-outer">
								<span class="link-inner">{{ level3.content }}</span>
							</a>
							<span v-else class="group-title">{{ level3.content }}</span>
							
							<!-- Ebene 4: Einträge -->
							<ul v-if="level3.children && level3.children.length" class="group-items stack-xxs">
								<li class="group-item" 
									v-for="(level4, itemIndex) in level3.children" 
									:key="level4.id || itemIndex">
									<a :href="level4.url || '#'" class="item-link link-outer">
										<span class="link-inner">{{ level4.content }}</span>
									</a>
								</li>
							</ul>
							
						</li>
					</ul>
					
				</div>
				
			</div>
			<div v-else class="tree-empty">Keine Inhalte verfügbar</div>
		</div>
	`,
	
	mounted() {
		console.log('🌲 MenuMegaPanel mounted with', this.tree ? this.tree.length : 0, 'columns')
		this.$emit('update:height', [this.$el.offsetHeight || 400])
	}
})